import router from '/@/router';
import { useUser } from './user';

import dynamicJson from './mockjsDynamicRoutes';
// 匹配views里面所有的.vue文件
const modules = import.meta.glob('./../../views/**/*.vue');
import Layout from '/@/layout/index.vue';
const menusItem = ref(<any[]>[]);
const loadRouters = () => {
  return new Promise((resolve, reject) => {
    get('/system/menu/getRouters').then((res: any) => {
      // console.log(res.data);
      if (res.code != 200) return reject(res.msg);
      menusItem.value = filterMenuItem(JSON.parse(JSON.stringify(res.data)));
      let dynamicRoutes = filterDynamicRoutes(JSON.parse(JSON.stringify(res.data)));
      // console.log(dynamicRoutes);
      router.addRoute(dynamicRoutes);
      resolve(dynamicRoutes);
    });
  });
};
export const usePermissionStore = defineStore('permission', () => {
  const routes = ref([]);
  const setMenusItem = (menus: any[]) => {
    menusItem.value = menus;
  };
  return {
    routes,
    menusItem,
    setMenusItem,
    loadRouters,
  };
});

// 动态菜单
const filterMenuItem = (routes: any[]) => {
  // 根据角色权限过滤菜单
  // console.log(useUser().permissions);
  return routes.map((route: any) => {
    Object.assign(route, {
      key: route.path,
      label: route.meta.title,
    });
    delete route.component;
    if (route.children && route.children.length !== 0) {
      // 有子目录
      route.children.forEach((item: any) => {
        Object.assign(item, {
          key: item.path,
          label: item.meta.title,
          path: route.path + item.path,
        });
        delete item.component;
      });
    }
    return route;
  });
};
// 动态路由处理
export function filterDynamicRoutes(routes: any[]) {
  let res: any = [];
  routes.forEach((route: any) => {
    if (!route.children || route.children.length === 0) {
      // 以及目录，没有子目录
      Object.assign(route, {
        component: loadView(route.component),
        // component: localFile[route.path.slice(1)],
      });
      res.push(route);
    } else {
      // 有子目录
      route.children.forEach((item: any) => {
        Object.assign(item, {
          component: loadView(item.component),
          // component: localFile[item.path.slice(1)],
          path: route.path + item.path,
        });
        res.push(item);
      });
    }
  });
  let dynamicRoutes = {
    path: '',
    component: Layout,
    redirect: '/homePage',
    name: 'homePageLayout',
    children: res,
  };
  return dynamicRoutes;
}

const loadView = (view: string) => {
  let res;
  for (const path in modules) {
    const dir = path.split('views/')[1].split('.vue')[0];
    if (dir === view) {
      res = () => modules[path]();
    }
  }
  return res;
};
export const initLoadRouters = () => {
  return new Promise((resolve, reject) => {
    loadRouters().then((res: any) => {
      resolve('');
    });
  });
};
// import homePage from '/@/views/homePage/index.vue';
// import flow from '/@/views/flow/index.vue';
// import sysInfo from '/@/views/sysSet/sysInfo/index.vue';
// import deviceManager from '/@/views/sysSet/deviceManager/index.vue';
// import user from '/@/views/sysSet/user/index.vue';
// import role from '/@/views/sysSet/role/index.vue';
// import countertop from '/@/views/sysSet/countertop/index.vue';
// import deviceCorrecting from '/@/views/sysSet/deviceCorrecting/index.vue';
// import consumable from '/@/views/sysSet/consumable/index.vue';
// import alarm from '/@/views/history/alarm/index.vue';
// import edit from '/@/views/history/edit/index.vue';
// import quantitative from '/@/views/history/quantitative/index.vue';
// import running from '/@/views/history/running/index.vue';
// import scan from '/@/views/history/scan/index.vue';
// let localFile = {
//   homePage,
//   flow,
//   sysInfo,
//   deviceManager,
//   user,
//   role,
//   deviceCorrecting,
//   countertop,
//   consumable,
//   alarm,
//   edit,
//   quantitative,
//   running,
//   scan,
// };
